import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import BScrollView from '../../../../components/BScrollView';
import { __ } from '../../../../i18n/l10n';
import { SportIds, type SportId } from '../../../../types/sports';
import LineUpPlayerContainer from '../LineUpPlayer/LineUpPlayerContainer';

const SPACING = 0.75; // em

enum Size {
  small = 'small',
  medium = 'medium',
}

type SIZESType = {
  minWidth: string;
  marginRight: string;
};

const SIZES: Record<Size, SIZESType> = {
  [Size.small]: {
    minWidth: '7.8em',
    marginRight: '1em',
  },
  [Size.medium]: {
    minWidth: '7.2em',
    marginRight: '1.5em',
  },
};

const Wrapper = styled.div``;

const ListTitle = styled.div`
  color: white;
  font-size: 120%;
  font-weight: bold;
  padding-left: ${SPACING}em;
`;

const ScrollViewWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  margin-top: 0.1em;

  ${Target.__MOBILE__
    ? css`
        --match-bet-filters-main-background: #000000;
      `
    : undefined}
`;

const InnerWrap = styled.div`
  display: inline-block;
  position: relative;
  height: 100%;
  overflow: hidden;
`;

const List = styled.div`
  position: relative;
  white-space: nowrap;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  transform-style: preserve-3d;
  padding: 0.1em ${SPACING}em 0 ${SPACING}em;
  font-size: 100%;
`;

type StyledLineUpPlayerContainerType = {
  $size: Size;
};

const StyledLineUpPlayerContainer = styled(LineUpPlayerContainer)<StyledLineUpPlayerContainerType>`
  margin-top: 0.5em;
  min-width: ${({ $size }) => SIZES[$size].minWidth};
  user-select: none;

  &:first-child {
    margin-left: 0em;
  }

  &:not(:last-child) {
    margin-right: ${({ $size }) => SIZES[$size].marginRight};
  }
`;

type LineUpSubstitutesListProps = {
  className?: string;
  playerIds: Array<number>;
  sportId: SportId;
};

const LineUpSubstitutesList = ({ className = '', playerIds, sportId }: LineUpSubstitutesListProps) => {
  const playerSize = useMemo(() => {
    switch (sportId) {
      case SportIds.RUGBY:
      case SportIds.RUGBY_LEAGUE:
        return Size.small;
      case SportIds.SOCCER:
      default:
        return Size.medium;
    }
  }, [sportId]);

  return playerIds.length ? (
    <Wrapper className={className}>
      <ListTitle>{__('Substitutes')}</ListTitle>
      <ScrollViewWrapper>
        <BScrollView vertical={false} isOverflowing>
          <InnerWrap>
            <List>
              {playerIds.map((playerId) => (
                <StyledLineUpPlayerContainer
                  key={`substitute-player-${playerId}`}
                  playerId={playerId}
                  $size={playerSize}
                />
              ))}
            </List>
          </InnerWrap>
        </BScrollView>
      </ScrollViewWrapper>
    </Wrapper>
  ) : null;
};

export default React.memo<LineUpSubstitutesListProps>(LineUpSubstitutesList);
